module.exports = __webpack_public_path__ + "static/media/STAF_bokmål_primærlogo_neg(hvit).804c4133.png";